export const pxTalkListActions = {
    PX_TALK_LIST_VISIBLE: 'PX_TALK_LIST_VISIBLE'
}
